import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormDateRangePicker,
  title: 'Date Range Picker',
  category: ComponentCategory.FormControls,
};
